export const NEW_RECORD = `newRecord`;
export const SAVE_AND_CONTINUE = `saveAndContinueBtn`;
export const DUPLICATE = `duplicateBtn`;
export const SAVE = `saveBtn`;
export const SAVE_DRAFT = `saveDraftBtn`;
export const REFRESH = `refreshBtn`;
export const PRINT = `printBtn`;
export const LIST_VIEW = `listView`;
export const GO_TO_RECORD = `goToRecordBtn`;
export const FIRST = `firstBtn`;
export const PREVIOUS = `previousBtn`;
export const NEXT = `nextBtn`;
export const LAST = `lastBtn`;
export const DELETE = `DELETE`;
export const APPROVAL = `approvalBtn`;
export const REVISE = `reviseBtn`;
export const UNREVISE = `unReviseBtn`;
export const TREE_VIEW = `treeViewBtn`;